import Service from "./Service";
const baseurl = '/api/intervencion';

export default {
    index(params={}) {
        return Service.get(`${baseurl}`,{
            params: params
        });
    }
}